import "./App.css";
import Main from "./components/main/Main";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./components/login/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "./theme/muiTheme";

function App() {
  return (
    <ThemeProvider theme={muiTheme}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route>
              <Route path="/" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard/*" element={<Main />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
